import * as React from "react";
import { useMemo } from "react";
import { styleSuffix, contentSuffix, deliverySuffix, shareSuffix } from "report/ReportRoutes";
import { NavTabs } from "components/common";
const pageNavigation = (prefix, isCreating = false) => [
  { description: "Overview", path: prefix, exactPathMatch: true },
  { description: "Content", path: `${prefix}${contentSuffix}` },
  { description: "Delivery", path: `${prefix}${deliverySuffix}` },
  { description: "Style", path: `${prefix}${styleSuffix}` },
  ...isCreating ? [{ description: "Share", path: `${prefix}${shareSuffix}` }] : []
];
const ReportCreationNavigation = ({ prefix, isCreating = false }) => {
  const paths = useMemo(() => pageNavigation(prefix, isCreating), [prefix, isCreating]);
  return /* @__PURE__ */ React.createElement(NavTabs, { items: paths });
};
export default ReportCreationNavigation;
